import React, { useState, useRef, useEffect, useContext } from 'react';
import { Link, Location } from '@reach/router';
import { useMutation } from '@apollo/react-hooks';

import { RB_COMPLETE } from '../../../../utils/constants';
import { AWARD_GEM_MUTATION } from '../../../../components/GemButton/services/graphql';
import AssignBand from '../../../Banding/components/assign';
import { AuthContext } from '../../../../services/auth/AuthProvider';
import { getFlagColor } from '../../../../utils/constants';
import SaveConfirm from '../../../../components/SaveConfirm';
import { Menu, Flag } from 'react-feather';
import Boomer from '../../../../images/loader-boomer.png'
import { useTranslation } from 'react-i18next';
import styles from './StudentTile.module.scss';
import cx from 'classnames';
import ReadingLogDates from './ReadingLogDates';
import SideModal from '../../../../components/SideModal';
import AddNote from '../../../Student/Components/Notes/AddNote';
import boomBassadorBlack from '../../../../images/boomBassador-icon-black.png';
import ImageFadeIn from 'react-image-fade-in';
import iconAddLog from '../../../../images/add_a_log_icon.png';


const StudentTile = ({ student, classInfo, onSelectStudent, viewType, intervalStats, selectedStudents, studentView = false }) => {
    const { t } = useTranslation();

    const [gemAwarded, setGemAwarded] = useState(false);
    const [showBand, setShowBand] = useState(false);
    const [addNote, setAddNote] = useState(false);
    const [menu, setMenu] = useState(false);
    const auth = useContext(AuthContext);
    const { userPermissions } = auth;

    const activeSchoolBooks = student.readingBooks.filter(book => book.status !== RB_COMPLETE && book.bookType === 1);

    const [awardGem] = useMutation(AWARD_GEM_MUTATION, {
        variables: {
            studentId: student.id
        },
        onCompleted: ({ addRewardGemToStudent }) => {
            if (addRewardGemToStudent.errors && addRewardGemToStudent.errors.length !== 0) {
                alert(t('error_awarding_gem'));
                return;
            }
            if (addRewardGemToStudent.student && addRewardGemToStudent.student.id) {
                setGemAwarded(true);
                setMenu(false);
            }
        }
    });

    const ref = useRef(null);
    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setMenu(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () =>
            document.removeEventListener('click', handleClickOutside, true);
    }, []);


    return (
        <>
            {studentView ?
                <li key={`student-${student.id}`} className={styles.student}>
                    <Location>
                        {() =>
                            <Link to={`/student/${student.id}`} state={{ classInfo: classInfo }} className={styles.studentInner}>
                                <div className={styles.studentHead}>
                                    <div className={styles.studentHeadMain}>
                                        <img src={student.boomerAvatarUrl ? `${student.boomerAvatarUrl}?v=${student.updatedAt.replace(/\s/g, '')}` : Boomer} className={styles.boomerImg} />
                                        {student.flagType && <Flag className={styles.studentHeadMainFlag} fill={getFlagColor(student.flagType)} color={getFlagColor(student.flagType)} size='20' />}
                                    </div>
                                </div>

                                <div className={styles.studentInfo}>
                                    <p>{student.name}</p>
                                    <div className={styles.studentBook}>
                                        {activeSchoolBooks.length === 0 ? <p className={styles.studentBookTitle}>{t('no_current_school_book')}</p> :
                                            <>
                                                {activeSchoolBooks.slice(0, 3).map(el =>
                                                    <p key={`active-b-${el.id}`} className={styles.studentBookTitle}>{el.book.title}</p>
                                                )}
                                                {activeSchoolBooks.length > 3 && <p>+{activeSchoolBooks.length - 3} more</p>}
                                            </>
                                        }
                                    </div>
                                </div>
                                <ReadingLogDates intervalStats={intervalStats} viewType={viewType} student={student} />
                                {student.currentReadingRank &&
                                    <p className={cx(styles.bandLabel, styles.bandLabelHasBand)}><span style={{ background: student.currentReadingRank.readingBandRank.colourCode }} className={styles.bandPill}></span>{student.currentReadingRank.readingBandRank.name}</p>
                                }
                            </Link>
                        }
                    </Location>
                </li>
                :
                <li className={styles.student} key={`student-${student.id}`}>
                    <Location>
                        {() =>
                            <Link to={`/student/${student.id}`} state={{ classInfo: classInfo }} className={styles.studentLink}></Link>
                        }
                    </Location>
                    <div className={styles.studentInner}>
                        <div className={styles.studentHead}>
                            <div className={cx("basic-form__group--check", styles.stCheck, styles.stCheckTop)}>
                                <input
                                    name="student"
                                    className="basic-form__check-box"
                                    type="checkbox"
                                    value={student.id}
                                    onChange={(e) => onSelectStudent(e)}
                                    checked={selectedStudents.indexOf(student.id) > -1}
                                    id={`st_${student.id}`}
                                />
                                <label className="basic-form__check-label" htmlFor={`st_${student.id}`}>&nbsp;</label>
                            </div>
                            {student.flagType && <Flag className={styles.studentHeadMainFlag} fill={getFlagColor(student.flagType)} color={getFlagColor(student.flagType)} size='20' />}
                            {student.isBoombassador && <ImageFadeIn style={{right: student.flagType ? '8rem' : '5rem'}} className={styles.studentHeadMainBoomBassador}  width="18px" height="22px" src={boomBassadorBlack} alt='boomBassador-icon' />}

                            <div className={styles.studentHeadMain}>
                                <img src={student.boomerAvatarUrl ? `${student.boomerAvatarUrl}?v=${student.updatedAt.replace(/\s/g, '')}` : Boomer} className={styles.boomerImg} />
                            </div>

                            <div ref={ref} className='dropdown dropdownTop'>
                                <button className={cx('dropdownBtn', { 'dropdownBtnIsActive': menu })} onClick={() => setMenu(!menu)}><Menu /></button>
                                {menu && (
                                    <ul className="dropdownMenu">
                                        <li><button onClick={() => awardGem()}>{t('award_bonus_gem')}</button></li>
                                        {
                                            student.school.readingBands && student.school.readingBands.length > 0 &&
                                            <li>
                                                <button onClick={() => setShowBand(true)}>
                                                    {student.currentReadingRank ? t('change_reading_band') : t('add_reading_band')}
                                                </button>
                                            </li>
                                        }

                                        {userPermissions && userPermissions.canManageStudentNotes &&
                                            <li>
                                                <button onClick={() => setAddNote(true)}>Add a note</button>
                                            </li>
                                        }


                                        {activeSchoolBooks.length === 0 ?
                                            <li><Link to={`/student/${student.id}`} state={{ classInfo: { ...classInfo, showAddBook: true } }}>{t('add_book')}</Link></li> :
                                            <li>
                                                <Location>
                                                    {({ location }) =>
                                                        <Link
                                                            to={`/logReading/${student.id}`}
                                                            state={{
                                                                oldLocation: JSON.parse(JSON.stringify(location)),
                                                                student: student,
                                                                schoolOnly: true
                                                            }}
                                                            onClick={() => setMenu(false)}
                                                        >
                                                            {t('log_reading')}
                                                        </Link>
                                                    }
                                                </Location>
                                            </li>
                                        }
                                        <li><Link to={`/student/${student.id}`} state={{ classInfo: { ...classInfo, activity: true } }}>View activity</Link></li>
                                    </ul>
                                )}
                            </div>
                        </div>
                        <div className={styles.studentInfo}>
                            {gemAwarded && <div className={styles.studentGemAwarded}><SaveConfirm message={t('gem_awared')} hideConfirm={() => setGemAwarded(false)} /></div>}
                            <p>{student.name}</p>
                            <div className={styles.studentBook}>
                                {activeSchoolBooks.length === 0 ? <p className={styles.studentBookTitle}>{t('no_current_school_book')}</p> :
                                    <>
                                        {activeSchoolBooks.slice(0, 3).map(el =>
                                            <p key={el.id} className={styles.studentBookTitle}>{el.book.title}</p>
                                        )}
                                        {activeSchoolBooks.length > 3 && <p>+{activeSchoolBooks.length - 3} more</p>}
                                    </>
                                }
                            </div>
                        </div>
                        <ReadingLogDates intervalStats={intervalStats} viewType={viewType} student={student} />

                        {student.currentReadingRank &&
                            <p className={`${cx(styles.bandLabel, styles.bandLabelHasBand)} ${styles.bandLabelRight}`}><span style={{ background: student.currentReadingRank.readingBandRank.colourCode }} className={styles.bandPill}></span>{student.currentReadingRank.readingBandRank.name}</p>
                        }
                        {
                            <Location>
                                {({ location }) =>
                                    <Link
                                        className={styles.zi}
                                        to={`/logReading/${student.id}`}
                                        state={{
                                            oldLocation: JSON.parse(JSON.stringify(location)),
                                            student: student,
                                            schoolOnly: true,
                                            classInfo: { ...classInfo, showAddBook: true }
                                        }}
                                        onClick={() => setMenu(false)}
                                    >
                                        <div className={`${cx(styles.bandLabel, styles.bandLabelHasBand)} ${styles.addLogButton}`}>
                                        <img src={iconAddLog} width={15} alt='Add reading log' />
                                        <p >{t('add_reading_log')}</p>
                                        </div>
                                    </Link>
                                }
                            </Location>
                        }
                        {showBand && <AssignBand student={student} close={() => setShowBand(false)} />}
                    </div>
                </li>
            }

            {addNote && (
                <SideModal closeModal={() => setAddNote(false)}>
                    <AddNote fromClassPage={true} student={student} close={() => setAddNote(false)} feedbackInModal={true} />
                </SideModal>
            )}
        </>
    )
}

export default StudentTile;